<template>
    <NuxtIcon
        :class="[definedColor(color) ? null : color, $attrs.class]"
        :customize="attrs.customize ?? customize"
        :size="definedSize(size) ? undefined : size"
        :style="iconStyles"
        :name="iconName" />
</template>

<script setup lang="ts">
import type { IconifyIconCustomizeCallback } from '@nuxt/icon/runtime/components/shared.js'

const {name, module, size, color, iconStrokeWidth, iconStroke, iconFill, iconOpacity} = defineProps<{
    name?: string,
    module?: string,
    size?: string,
    color?: string | [string, number],
    iconStrokeWidth?: number,
    iconStroke?: string,
    iconFill?: string,
    iconOpacity?: number,
}>()

const iconName = computed(() => {
    if (name) return name
    if (module) return $getModuleIcon(module || undefined) ?? 'none'
    return 'none'
})

const attrs = useAttrs() as {
    class?: string
    customize?: boolean | IconifyIconCustomizeCallback | null | undefined
}

const {build, definedColor, definedSize} = useStyles()

const iconStyles = computed(() => build().textColor(color).sizing(size ?? null).watchFor(attrs.class ?? '').get())

const customize = (content: string) => {
    let newContent = content

    if (iconStrokeWidth || iconStrokeWidth === 0)
        newContent = newContent.replace(/stroke-width="[^"]*"/g, `stroke-width="${iconStrokeWidth}"`)
    if (iconStroke)
        newContent = newContent.replace(/stroke="[^"]*"/g, `stroke="${iconStroke}"`)
    if (iconFill)
        newContent = newContent.replace(/fill="[^"]*"/g, `fill="${iconFill}"`)
    if (iconOpacity || iconOpacity === 0)
        newContent = newContent.replace(/opacity="[^"]*"/g, `opacity="${iconOpacity}"`)
    return newContent
}
</script>